import { render, staticRenderFns } from "./wrappBadges.vue?vue&type=template&id=12df7ec4&scoped=true&"
import script from "./wrappBadges.vue?vue&type=script&lang=js&"
export * from "./wrappBadges.vue?vue&type=script&lang=js&"
import style0 from "./wrappBadges.vue?vue&type=style&index=0&id=12df7ec4&lang=scss&scoped=true&"
import style1 from "./wrappBadges.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12df7ec4",
  null
  
)

export default component.exports